export interface Credentials {
  readonly email: string;
  readonly password: string;
}

export interface AuthenticatedUser {
  readonly id: string;
  readonly fullName: string;
  readonly email: string;
  readonly roles: readonly string[];
}

export interface AuthSession {
  readonly accessToken: string;
  readonly refreshToken: string | null;
  readonly expiresAt: Date;
  readonly user: AuthenticatedUser;
}

export function isSessionExpired(session: AuthSession, now: Date = new Date()): boolean {
  return session.expiresAt.getTime() <= now.getTime();
}

export function hasRole(user: AuthenticatedUser, role: string): boolean {
  return user.roles.some((r) => r.toLowerCase() === role.toLowerCase());
}
